import {
  browserLocalPersistence,
  isSignInWithEmailLink,
  onAuthStateChanged,
  setPersistence,
  signInWithEmailLink,
} from "firebase/auth";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getFirebaseAuth } from "../firebase/firebaseService";
import { getAuthConfig } from "../config/AuthConfigContext";
import { LoaderMessage } from "../components/loaderMessage/loaderMessage";
import { loginSuccess } from "../state/authSlice";
import { useAuthDispatch } from "../state/AuthStoreProvider";

const FinalSignIn = () => {
  const navigate = useNavigate();
  const dispatch = useAuthDispatch();
  const config = getAuthConfig();
  const authRedirectPath = config?.authRedirectPath ?? "/auth";

  useEffect(() => {
    const completeSignIn = async () => {
      if (typeof window === "undefined") return;

      const firebaseAuth = getFirebaseAuth();

      if (isSignInWithEmailLink(firebaseAuth, window.location.href)) {
        let email = window.localStorage.getItem("emailForSignIn");

        if (!email) {
          email =
            window.prompt("Please provide your email for confirmation") || null;
        }

        if (!email) {
          console.error("Email is required for sign-in.");
          navigate(authRedirectPath);
          return;
        }

        try {
          await setPersistence(firebaseAuth, browserLocalPersistence);

          const result = await signInWithEmailLink(
            firebaseAuth,
            email,
            window.location.href,
          );

          window.localStorage.removeItem("emailForSignIn");

          dispatch(
            loginSuccess({
              email: result.user.email ?? "",
              id: result.user.uid,
            }),
          );

          navigate("/");
        } catch (error) {
          console.error("Error signing in with email link:", error);
          navigate(authRedirectPath);
        }
      } else {
        console.log("Not a sign-in email link, redirecting to auth");
        navigate(authRedirectPath);
      }
    };

    completeSignIn();
  }, [dispatch, navigate, authRedirectPath]);

  useEffect(() => {
    const firebaseAuth = getFirebaseAuth();
    const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
      if (user) {
        dispatch(
          loginSuccess({
            email: user.email ?? "",
            id: user.uid,
          }),
        );
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return (
    <div className="final-sign-in--container flex h-full items-center justify-center">
      <LoaderMessage message={"Signing in..."} />
    </div>
  );
};

export default FinalSignIn;
